import React from 'react';
import { RobotOutlined } from '@ant-design/icons';
import './style.css';

const CHAT_URL = 'https://devops.proxywareai.com/webhook/a6e2113f-1694-44a6-85d0-07ea95e39bf0/chat';

const FloatingChat = () => {
  const openChat = () => {
    window.open(CHAT_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      className="floating-chat-button"
      onClick={openChat}
      aria-label="Open AI Chat"
    >
      <RobotOutlined className="floating-chat-icon" />
    </button>
  );
};

export default FloatingChat;
